import React, { useContext } from 'react';

export type PreviewDevice = 'desktop' | 'mobile';

// Lets an embedded preview (e.g. the homepage editor) render its subtree as a given device
// without affecting the rest of the app. Undefined means "use the real viewport".
const PreviewDeviceContext = React.createContext<PreviewDevice | undefined>(undefined);

export const PreviewDeviceProvider = PreviewDeviceContext.Provider;

export const usePreviewDevice = () => useContext(PreviewDeviceContext);
